import React from "react";
import { PERIOD_OPTIONS, REPORT_PERIODS, toDateString } from "./reportUtils";

const ReportPeriodFilter = ({
  period,
  dates,
  onPeriodChange,
  onCustomChange,
}) => (
  <div className="rp-period" role="group" aria-label="Reporting period">
    {PERIOD_OPTIONS.map(([value, label]) => (
      <button
        type="button"
        key={value}
        className={period === value ? "active" : ""}
        onClick={() => onPeriodChange(value)}
      >
        {label}
      </button>
    ))}
    {period === REPORT_PERIODS.CUSTOM && (
      <div className="rp-custom-dates">
        <label>
          From
          <input
            type="date"
            value={dates.startDate}
            max={dates.endDate}
            onChange={(e) => onCustomChange("startDate", e.target.value)}
          />
        </label>
        <label>
          To
          <input
            type="date"
            value={dates.endDate}
            min={dates.startDate}
            max={toDateString(new Date())}
            onChange={(e) => onCustomChange("endDate", e.target.value)}
          />
        </label>
      </div>
    )}
  </div>
);

export default ReportPeriodFilter;
